<template>
  <div
    class="search-box-open float-left"
    v-if="$router.currentRoute.path !== '/add'"
  >
    <router-link class="d-block pr-0" to="/add_client">
      <img :src="addClientIcon" class="search-icon add-client-icon" alt="img" />
    </router-link>
  </div>
  <img
    :src="addClientIcon"
    class="month-view-cal split-icon-header"
    alt="img"
    v-else
  />
</template>

<script>
export default {
  computed: {
    addClientIcon() {
      return require("../../assets/img/m_addClient.png");
    }
  },
  props: {
    click: Function
  }
};
</script>

<style scoped>
img {
  max-width: 30px;
}
</style>
